import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '../api';
import { AssetPurchaseOrderApprovalResponseModel } from '~/models/administration/AssetPurchaseOrderApprovalResponseModel';

@Injectable({
  providedIn: 'root'
})
export class AssetPoApprovalsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.adminAssets);
}


getAssetPurchaseOrderApproval(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<AssetPurchaseOrderApprovalResponseModel[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
}


getAssetPurchaseOrderApprovals() {
    return this.http.get<any>(this._url());
}

getAssetPurchaseOrderApprovalById(id: number) {
    return this.http.get<any>(`${this._url()}/${id}`);
}

updateAssetPurchaseOrderApproval(model: any, id: number) {
    return this.client.put(`${this._url()}/${id}`, model);
}

createAssetPurchaseOrderApproval(model: any) {
    return this.client.post(this._url(), model);
}

private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AssetPurchaseOrderApprovals${v}`);
}
}
